/**
 * @file Container component for dynamically inject detail types in the overlay.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { ViewContainerRef, ComponentFactoryResolver, EventEmitter } from '@angular/core';
import { ComponentRegistry } from '../../core/component-registry';
import { AbstractBase } from '../../core/helpers/abstract-base';
/**
 * Container component for dynamically inject detail types in the overlay.
 * @export
 * @class DetailContainerComponent
 */
var DetailContainerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DetailContainerComponent, _super);
    /**
     * Creates an instance of DetailContainerComponent.
     * @param {ViewContainerRef} containerRef Represents a container where one or more views can be attached to a component.
     * @param {ComponentFactoryResolver} factoryResolver Helper class to resolve and create components.
     * @memberOf DetailContainerComponent
     */
    function DetailContainerComponent(containerRef, factoryResolver) {
        var _this = _super.call(this) || this;
        _this.containerRef = containerRef;
        _this.factoryResolver = factoryResolver;
        /**
         * Gets, sets the reference of the configuration used by de detail component.
         * @private
         * @type {ComponentConfiguration}
         * @memberOf DetailContainerComponent
         */
        _this._configuration = undefined;
        /**
         * Gets, sets the key of the entity shown by this detail.
         */
        _this.entityKey = undefined;
        /**
         * Sets the flag indicating whether or not the component is shown in the overlay.
         */
        _this.overlayMode = true;
        /**
         * Event notifying that the detail is closing. Is used in the overlay.
         * @type {EventEmitter<string>}
         */
        _this.closing = new EventEmitter();
        /** Event triggered when a entity from the list is selected. */
        /** Gets, sets the DetailBase instance of this container. */
        _this.instance = null;
        /** Reference to the component type name to create. */
        _this._component = undefined;
        return _this;
    }
    Object.defineProperty(DetailContainerComponent.prototype, "configuration", {
        /**
         * Sets the configuration used by de detail component.
         * @readonly
         * @type {ComponentConfiguration}
         * @memberOf DetailContainerComponent
         */
        get: function () {
            return this._configuration;
        },
        /**
         * Gets the configuration used by de detail component.
         * @memberOf DetailContainerComponent
         */
        set: function (config) {
            this._configuration = config;
            this.createComponent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailContainerComponent.prototype, "component", {
        /**
         * Sets the component type to create within this container.
         * @param value The name of component type.
         * @memberOf DetailContainerComponent
         */
        set: function (value) {
            this._component = value;
            this.createComponent();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Create the component within this container and sets the needed properties.
     * @private
     * @memberOf DetailContainerComponent
     */
    DetailContainerComponent.prototype.createComponent = function () {
        var _this = this;
        if (this._component == null) {
            return;
        }
        if (this._configuration == null) {
            return;
        }
        var editor = ComponentRegistry.getComponent('detail', this._component);
        if (this.containerRef.length > 0) {
            this.containerRef.clear();
        }
        var componentFactory = this.factoryResolver.resolveComponentFactory(editor);
        var ref = this.containerRef.createComponent(componentFactory, 0);
        this.instance = ref.instance;
        this.instance.overlayMode = this.overlayMode;
        this.subscriptionPool.add(this.instance.closing.subscribe(function (event) {
            _this.closing.next(event);
        }));
        this.instance.entityKey = this.entityKey;
        this.instance.configuration = this._configuration;
    };
    return DetailContainerComponent;
}(AbstractBase));
export { DetailContainerComponent };
